import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth0 } from '@auth0/auth0-react';
import Preloader from '../../components/Preloader/Preloader';

function AuthCallback() {
  // const navigate = useNavigate();
  // const { isAuthenticated, isLoading, error } = useAuth0();

  // useEffect(() => {
  //   if (!isLoading) {
  //     if (isAuthenticated) {
  //       // Auth0 SDK handles the authentication automatically
  //       // The redirect will be handled by the Auth0Provider's onRedirectCallback
  //       const destination = localStorage.getItem('loginRedirect') || '/farms';
  //       localStorage.removeItem('loginRedirect');
  //       navigate(destination, { replace: true });
  //     } else if (error) {
  //       // Handle authentication error
  //       console.error('Authentication error:', error);
  //       navigate('/', { replace: true });
  //     }
  //   }
  // }, [isAuthenticated, isLoading, error, navigate]);

  return <Preloader />;
}

export default AuthCallback;
